export const ERROR_500 = {
  non_field_errors: `An error has occurred and we're working to fix the problem! We'll be up and running shortly.`,
}

export const MODAL_MESSAGES = {
  FREE_COURSE:
    "This is course free. You can access all the materials and can get your certificate right away.",
  PAYMENT_PENDING:
    "Thank you for enrolling to this course. You can start learning once we confirm your payment.",
  PAYMENT_COMPLETE:
    "Thank you for completing your payment. You may now proceed with your course.",
  ENROLLMENT_SUCCESSFUL:
    "Thank you for completing your enrollment. You can now access the course.",
  BUNDLE_PAYMENT_PENDING:
    "Thank you for enrolling to this bundle. You can start learning once we confirm your payment.",
  BUNDLE_PAYMENT_COMPLETE:
    "Thank you for completing your payment. You may now proceed with your courses.",
  BUNDLE_ENROLLMENT_SUCCESSFUL:
    "Thank you for completing your enrollment. You can now access the courses.",
  ALREADY_ENROLLED:
    "Unable to process enrollment. Please select a new one or refresh the page.",
  NOT_VERIFIED:
    "Please open your e-mail and check for a message with Subject: Apptitude: Email Verification. If it's not in the Inbox, please check your spam folder. If there is really no such e-mail, click Resend E-mail button below.",
  PAYMENT_FAILED:
    "We encountered an error. Please try again or send us an email",
  PAYMENT_FAILED_CHANNEL:
    "We encountered an error. Please try a different payment method.",
  UPLOAD_PROFILE_PHOTO_SUCCESSFUL: "Profile photo has been updated.",
  ENROLLMENT_SUCCESSFUL_SPIEL: "Thank you for completing your enrollment.",
  SSO_REGISTRATION_SUCCESS:
    "Congratulations, your account has been successfully created.",
  PAYMENT_LATER_SUCCESS:
    "Thank you for completing your payment. You will be notified once your certificate is available.",
  PAYMENT_LATER_PENDING:
    "Thank you for processing your payment. You can get your certificate once we confirm your payment.",
}

export const STATEMENT_CONTENT = {
  AFFIRMATION: `
      <p>I hereby certify and affirm that:</p>
      <ol>
        <li>All the information I have supplied to the Platform including, but not limited to those pertaining to my identity are true, correct, updated, and complete. I know and understand that any false and/or incomplete information provided amounts to misrepresentation on my part and will result in the denial or revocation of the certificate to be issued after the conduct of this online Mandatory Continuing Legal Education (MCLE) course, without prejudice to other legal and administrative action for such misrepresentation or omission which may be undertaken against me.</li>
        <li>I will uphold intellectual honesty in personally attending, viewing, and completing this online MCLE course.</li>
        <li>I expressly acknowledge that if I am found to have employed any fraud, misrepresentation, and/or deceit in availing of this online MCLE course, I shall be subjected to the appropriate disciplinary action pursuant to Rule 139-B (Disbarment and Discipline of Attorneys) of the Rules of Court, as amended.</li>
        <li>I am aware that there will be an evaluation/feedback form at the end of the course which I must accomplish, as one of the pre-requisites for the issuance of the certificate of completion.</li>
        <li>I have read, understood, and will strictly abide by the Platform’s terms and conditions of use, available at <a href="https://apptitude.xyz/terms-and-conditions" target="_blank">https://apptitude.xyz/terms-and-conditions</a>, and privacy policy, available at <a href="https://apptitude.xyz/privacy-policy" target="_blank">https://apptitude.xyz/privacy-policy</a>.</li>
        <li>I expressly acknowledge that clicking "Agree" and/or entering my signature herein shall constitute my electronic signature and shall be deemed conclusive proof of my consent to this statement of affirmation. I likewise consent to the affixing of the said signatures on the electronic copies of the statement of affirmation which may be required to be transmitted to the MCLE Office.</li>
      </ol>
  `,
}

export const MCLE_SNAPSHOT =
  "In compliance with MCLE Rules, this session will include random snapshots. You will be photographed at random intervals."

export const getSuccessRegistrationSpiel = (fb_group, amount) => {
  return `As a member of ${fb_group}, you've been given ${amount} L2E Coins which can be used as a discount for enrollment to a 36-Unit MCLE Course Bundle of your choice.`
}
